export const CITY = 'city';
export const CITY_QUERY_PARAM = 'city_id';
export const DEFAULT_CITY_ID = 1;
